(function () {
  'use strict';

  angular
    .module('app')
    .component('bookingItemServiceItemCostTable', bookingItemServiceItemCostTable());

  function bookingItemServiceItemCostTable() {
    return {
      bindings: {
        bookingItemServiceItem: '<',
        currency: '<',
      },
      controller: function () {},
      controllerAs: 'vm',
      templateUrl:
        './app/ajs/bookings/booking-items/booking-item-service-items/components/' +
        'booking-item-service-item-cost-table/booking-item-service-item-cost-table.component.html',
    };
  }
})();
